var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-crumb-container flex"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-caret-right"}},[_vm._l((_vm.bConfigList),function(b,i){return [(b.type == 'router')?_c('el-breadcrumb-item',{key:i,attrs:{"to":{ name: b.router }}},[_vm._v(_vm._s(b.name))]):_c('el-breadcrumb-item',{key:i},[_vm._v(_vm._s(b.name))])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }